<app-card-header [header]="header"></app-card-header>
<app-sdc-card *ngIf="isComercial || isBasica" (calcSdc)="makeCalcSdc($event)"></app-sdc-card>
<br>
<app-sec002-card-I (objQua007)="getQua007Data($event)" (objQua007PreBasica)="PreBasicaQua007Data($event)"
    (mkCalc)="makeCalculations($event)"></app-sec002-card-I>
<br>
<app-sec002-card-II (mkCalc)="makeCalculations($event)" (mkCalcPrebasica)="makeCalcPrebasica($event)"
    (mkCalcDate)="calcDatePreBasica($event)" (isRessect)="getRessect($event)"
    [geracao]="this.sec002CardIComponent?.formulario?.get('geracao_basica')"></app-sec002-card-II>
<br>
<app-sec002-card-III (mkCalc)="makeCalculations($event)" (reqSecagem)="reqSecagem()"
    [isRessect]="isRessectSelected"></app-sec002-card-III>
<br>
<app-sec002-card-IV (mkCalc)="makeCalculations($event)"></app-sec002-card-IV>
<br>
<app-sec002-card-V (mkCalc)="makeCalculations($event)" (updateLocalAtualEmitter)="calcLocalAtual()"></app-sec002-card-V>
<br>
<app-sec002-card-VI (mkCalc)="makeCalculations($event)"></app-sec002-card-VI>
<br>
<app-sec002-card-VII></app-sec002-card-VII>
<br>
<app-sec002-card-VIII></app-sec002-card-VIII>
<br>
<app-sec002-card-IX></app-sec002-card-IX>
<br>
<app-sec002-card-X></app-sec002-card-X>
<br>
<div class="row">
    <div class="col-lg col-md col-xs col-sm col-xl cardAction text-right">
        <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Voltar"
            [routerLink]="['/formsec002']">
            <i class="fa fa-undo fa-1x btnIcon"></i> Voltar
        </button>
        <ng-container *ngIf="!btnCollapse">
            <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Maximizar"
                (click)="collapseAll()">
                <i class="fa fa-window-maximize fa-1x btnIcon"></i> Maximizar
            </button>
        </ng-container>
        <ng-container *ngIf="btnCollapse">
            <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Minimizar"
                (click)="collapseAll()">
                <i class="fa fa-window-minimize fa-1x btnIcon"></i> Minimizar
            </button>
        </ng-container>
        <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Limpar" (click)="cleanAll()"
            [hidden]="!enableButtons | async">
            <i class="fa fa-paint-brush fa-1x btnIcon"></i> Limpar
        </button>
        <button mat-flat-button color="primary" class="iconFooter btnSize mt-2" matTooltip="Salvar" (click)="save()"
            [hidden]="!enableButtons | async" *ngIf="!disablesave">
            <i class="fa fa-floppy-o fa-1x btnIcon"></i> Salvar
        </button>
    </div>
</div>